var path = 'jangl/jangl-input/template.html';
var html = "<div class=form-group> <label for={{$ctrl.name}} class=control-label ng-class=\"{ 'required': $ctrl.required }\">{{$ctrl.label}}</label> <input type={{$ctrl.type}} class=form-control name={{$ctrl.name}} placeholder={{$ctrl.placeholder}} ng-model=$ctrl.model ng-required=$ctrl.required ng-pattern=$ctrl.pattern step={{$ctrl.step}} ng-disabled=$ctrl.disabled ui-mask={{$ctrl.mask}} /> <div class=error-messages ng-show=\"$ctrl.form.$submitted || $ctrl.form[$ctrl.name].$touched\"> <div ng-repeat=\"err in $ctrl._errorMessages\" ng-show=$ctrl.form[$ctrl.name].$error[err.type]>{{err.msg}}</div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/jangl/jangl-input/template.html
// module id = 367
// module chunks = 0